import client from './client';

export const authApi = {
  // Register new user
  register: async (data) => {
    const response = await client.post('/auth/register', data);
    return response.data;
  },

  // Login and get tokens
  login: async (email, password) => {
    const formData = new URLSearchParams();
    formData.append('username', email);
    formData.append('password', password);

    const response = await client.post('/auth/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response.data;
  },

  // Refresh access token
  refresh: async (refreshToken) => {
    const response = await client.post('/auth/refresh', {
      refresh_token: refreshToken,
    });
    return response.data;
  },

  // Get current user profile
  getProfile: async () => {
    const response = await client.get('/auth/me');
    return response.data;
  },

  // Logout - also disconnects all broker accounts
  logout: async () => {
    const response = await client.post('/auth/logout');
    return response.data;
  },
};

export default authApi;
